(function() {
    'use strict';

    angular
        .module('app')
        .directive('restricted', restricted);

    restricted.$inject = ['$window'];
    
    function restricted ($window) {
        // Usage:
        //     <restricted></restricted>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope, element, attrs) {

            config = {
                create: true,
                sortField: 'text',

            }

            var options = {

            }

            $(element).selectize(options)
        }
    }

})();